export enum AuthMode {
  header = "header",
  cookie = "cookie",
}
